export default {
  methods: {
    async render_one_right(data, index) {
      let colorArr = ['#399EF9', '#34C9C6', '#4ACA6E', '#F7D335', '#F0607A', '#965FE1',]
      let seriesData = [{ name: '报名费', value: data.signUpSales }, { name: '秒杀', value: data.seckillSales }, { name: '拼团', value: data.groupSales },]
      seriesData = !index ? seriesData : [seriesData[index]]
      colorArr = !index ? colorArr : [colorArr[index]]
      let text = !index ? data.totalSales : seriesData[0].value
      let option = {
        color: colorArr,
        title: {
          text: '¥ ' + text,
          subtext: "销售额",
          x: "center",
          y: "center",
          textStyle: {
            fontWeight: "normal",
            fontSize: 18,
          },
          z: 1,
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow'
          },
          confine: true
        },
        legend: {
          show: false
        },
        series: [
          {
            type: "pie",
            radius: ["60%", "80%"],
            center: ["50%", "50%"],
            hoverAnimation: true,
            z: 10,
            itemStyle: {
              normal: {
                borderWidth: 5,
                borderColor: "#FFF",
              },
            },
            label: {
              show: false,
            },
            data: seriesData,
            labelLine: {
              show: false,
            },
          },
        ],
      };
      let $instance = this.$echarts.init(this.$refs['oneRightChats']);
      $instance.setOption(option, true);
      $instance.on('click', params => {
        this.dialogFormVisibleLeft = true
        this.leftDialog(colorArr)
      });
    }
  }
}